import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthAvailableTournament } from 'modules/auth/domain/interfaces/auth-available-tournament';
import { createGetAvailableTournamentsByFilterReducer, createGetAvailableTournamentsReducer } from './reducers';

export interface AvailableTournamentsSliceState {
  isLoading: boolean;
  isLoaded: boolean;
  error?: any;

  processing: boolean;
  processedName?: string;

  userId?: number;

  tournaments: AuthAvailableTournament[];
  limit: number;
  allDataLoaded: boolean;

  filter: {
    text: string;
    items: AuthAvailableTournament[];
    allDataLoaded: boolean;
  };
}

const initialState: AvailableTournamentsSliceState = {
  isLoading: false,
  isLoaded: false,

  processing: false,

  tournaments: [],
  limit: 20,
  allDataLoaded: false,

  filter: {
    text: '',
    items: [],
    allDataLoaded: false,
  },
};

export const availableTournamentsSlice = createSlice({
  name: 'availableTournaments',
  initialState,
  reducers: {
    resetError: (state) => {
      state.error = undefined;
    },
    reset(state, action: PayloadAction<{ userId: number }>) {
      state.userId = action.payload.userId;
      state.tournaments = [];
      state.allDataLoaded = false;
      state.filter = { text: '', items: [], allDataLoaded: false };
    },
    setFilter: (state, action: PayloadAction<{ text: string }>) => {
      state.filter.text = action.payload.text;
    },
    addTournaments: (state, action: PayloadAction<AuthAvailableTournament[]>) => {
      state.tournaments.push(...action.payload);
    },
  },
  extraReducers: (builder) => {
    createGetAvailableTournamentsReducer(builder);
    createGetAvailableTournamentsByFilterReducer(builder);
  },
});

export const { resetError, reset, setFilter, addTournaments } = availableTournamentsSlice.actions;

export default availableTournamentsSlice.reducer;
